import { minutesToMs } from "./helpers/time.js";
const authStorageKey = "auth";
const trustedDeviceStorageKey = "trustedDeviceId";
const stagingHades = "https://staging-hades-backend.dental21.de";
const productionHades = "https://hades-backend.dental21.de";
const refreshTokenHeader = "x-refresh-token";
const isTrustedDeviceHeader = "X-Auth-Requires-2FA";
const credentialEvent = "credentials-changed";
const redirectCookieKey = "redirectLocation";
const missingConsentsHeader = "missing-consents";
const refreshTokenThreshold = minutesToMs(5);
export {
  authStorageKey,
  credentialEvent,
  isTrustedDeviceHeader,
  missingConsentsHeader,
  productionHades,
  redirectCookieKey,
  refreshTokenHeader,
  refreshTokenThreshold,
  stagingHades,
  trustedDeviceStorageKey
};
